/**
 * Role id for system / portal administrators (must match Home.vue switch → systemadmin).
 * Only this role may access routes with meta.requiresPortalAdmin.
 */
export const ROLE_SYSTEMADMIN = 1;

/** Coordinator — dashboard shows only studies where tbl_sys_study.email_coordinator matches login username. */
export const ROLE_COORDINATOR = 4;
/** Beleidsmedewerker — no dashboard. */
export const ROLE_BELEIDSMEDEWERKER = 5;
/** Examenbureau — no dashboard. */
export const ROLE_EXAMENBUREAU = 6;
/** Examenbureau coordinator — no dashboard (same restriction as examenbureau). */
export const ROLE_EXAMENBUREAU_COORDINATOR = 11;
/** Quality Coordinator — same menu/dashboard scope as coordinator, plus planning menus. */
export const ROLE_QUALITY_COORDINATOR = 13;

const DASHBOARD_BLOCKED_ROLE_IDS = [ROLE_BELEIDSMEDEWERKER, ROLE_EXAMENBUREAU, ROLE_EXAMENBUREAU_COORDINATOR];

export function getParsedUserFromStorage() {
	try {
		var rawAccess = localStorage.getItem("access");
		if (rawAccess == null || rawAccess === "" || rawAccess === "false") {
			return null;
		}
		return JSON.parse(localStorage.getItem("user") || "null");
	} catch (e) {
		return null;
	}
}

/**
 * Role id from session user (top-level role_id or nested tbl_sys_role from Sequelize).
 */
export function effectiveDashboardRoleId(user) {
	if (!user) {
		return null;
	}
	var r = user.role_id;
	if (r == null && user.tbl_sys_role != null) {
		var nested = user.tbl_sys_role;
		r = nested.id != null ? nested.id : nested.role_id;
	}
	if (r == null) {
		return null;
	}
	var n = Number(r);
	return Number.isNaN(n) ? null : n;
}

export function userRoleId() {
	var u = getParsedUserFromStorage();
	return effectiveDashboardRoleId(u);
}

/** Roles that may not open the dashboard at all (redirected away from /main). */
export function isDashboardBlockedRole(roleId) {
	if (roleId == null || Number.isNaN(roleId)) {
		return false;
	}
	return DASHBOARD_BLOCKED_ROLE_IDS.indexOf(roleId) !== -1;
}

/** Full dashboard (birthdays, all absences, sectors). */
export function isDashboardFullRole(roleId) {
	if (roleId == null || Number.isNaN(roleId)) {
		return true;
	}
	if (isDashboardBlockedRole(roleId)) {
		return false;
	}
	if (
		Number(roleId) === ROLE_COORDINATOR ||
		Number(roleId) === ROLE_QUALITY_COORDINATOR
	) {
		return false;
	}
	return true;
}

export function isDashboardCoordinatorRole(roleId) {
	var n = Number(roleId);
	return n === ROLE_COORDINATOR || n === ROLE_QUALITY_COORDINATOR;
}

/** Inschrijvingen-dashboard: zelfde scope als API (volledig of coördinator-gefilterd). */
export function isDashboardRegistrationsRole(roleId) {
	if (isDashboardBlockedRole(roleId)) {
		return false;
	}
	return isDashboardFullRole(roleId) || isDashboardCoordinatorRole(roleId);
}

/** Login identity for dashboard API coordinator filter (username is meestal e-mail). */
export function dashboardCoordinatorIdentity(user) {
	if (!user) {
		return "";
	}
	var u = user.username != null ? String(user.username).trim() : "";
	if (u) {
		return u;
	}
	if (user.email != null && String(user.email).trim()) {
		return String(user.email).trim();
	}
	return "";
}

/** First menu path to send users who cannot use the dashboard (must exist for their role). */
export function dashboardBlockedRedirectPath(roleId) {
	switch (Number(roleId)) {
		case ROLE_BELEIDSMEDEWERKER:
			return "/schooladmin/employeetimesheet";
		case ROLE_EXAMENBUREAU:
			return "/schooladmin/admin_task";
		case ROLE_EXAMENBUREAU_COORDINATOR:
			return "/schooladmin/exam_coordinator";
		default:
			return "/schooladmin/employeetimesheet";
	}
}

export function userMustResetCredentials() {
	try {
		var rawAccess = localStorage.getItem("access");
		if (rawAccess == null || rawAccess === "" || rawAccess === "false") {
			return false;
		}
		var user = JSON.parse(localStorage.getItem("user") || "null");
		if (!user) {
			return false;
		}
		return Number(user.reset_credentials) === 1;
	} catch (e) {
		return false;
	}
}

export function userHasPortalAdminAccess() {
	try {
		var rawAccess = localStorage.getItem("access");
		if (rawAccess == null || rawAccess === "" || rawAccess === "false") {
			return false;
		}
		var user = JSON.parse(localStorage.getItem("user") || "null");
		if (!user || user.id == null) {
			return false;
		}
		return Number(user.role_id) === ROLE_SYSTEMADMIN;
	} catch (e) {
		return false;
	}
}
